import React from 'react';

const Popover = ({ label, popoverContent, data, icon, styleObj={}, isOpen }) => {
  return (
    <div className="popover__wrapper">
      {/*<a href="#">
        <h2 className="popover__title">Hover:me</h2>
      </a>*/}
      <div className={`popover__content${isOpen? ' popover__content_visible': ''}`}>
        {popoverContent(data)}
      </div>
    </div>
  )
}

export default Popover;
